import { render, staticRenderFns } from "./liverlist.vue?vue&type=template&id=67d0e30e&scoped=true"
import script from "./liverlist.vue?vue&type=script&lang=js"
export * from "./liverlist.vue?vue&type=script&lang=js"
import style0 from "./liverlist.vue?vue&type=style&index=0&id=67d0e30e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d0e30e",
  null
  
)

export default component.exports